<!-- Navigation -->
@if (isScreenSmall) {
  <fuse-vertical-navigation class="dark bg-gray-900 print:hidden" [mode]="'over'" [name]="'mainNavigation'"
    [navigation]="data.navigation.default" [opened]="false">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
      <!-- Logo -->
      <div class="flex items-center py-6 px-4">
        <a [routerLink]="['/home']">
          <img class=" w-18" alt="IAPMO SCB Certification Management Database"
            src="assets/images/logo/logo_SCB.jpg">
          </a>
        </div>
      </ng-container>
    </fuse-vertical-navigation>
  }

  <!-- Wrapper -->
  <div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div
      class="relative flex flex-0 items-center w-full h-16 sm:h-20 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
    @if (!isScreenSmall) {
      <!-- Logo -->
      <div class="flex items-center mx-2 lg:mr-8">
        <div class="hidden lg:flex">
          <!-- <img class="dark:hidden w-24" src="assets/images/logo/logo-text.svg">-->
          <img class="flex w-22" src="assets/images/logo/logo_SCB.jpg">
        </div>
        <!-- <img class="flex lg:hidden w-8" src="assets/images/logo/logo.svg"> -->
      </div>
      <!-- Horizontal navigation -->
      <fuse-horizontal-navigation class="mr-2" [name]="'mainNavigation'"
      [navigation]="data?.navigation.horizontal"></fuse-horizontal-navigation>
    }
    <!-- Navigation toggle button -->
    <!-- <ng-container *ngIf="isScreenSmall">
    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
    </button>
  </ng-container> -->
  <!-- Components -->
  <div class="flex items-center pl-2 ml-auto space-x-2">

    @if (clients && clients?.length > 0) {
      <mat-form-field appearance="outline" class="w-full mt-1">
        <mat-select [formControl]="formControl" [placeholder]="'Select Client'" #singleSelect>
          @for (item of clients; track item) {
            <mat-option [value]="item.clientId">
              {{item?.companyName}}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (!isScreenSmall) {
      <fuse-fullscreen></fuse-fullscreen>
    }
    <user-menu></user-menu>
  </div>
</div>

<!-- Content -->
<div class="flex flex-col flex-auto w-full">
  <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
  Otherwise, layout changes won't be registered and the view won't be updated! -->
  @if (true) {
    <router-outlet></router-outlet>
  }
</div>
</div>
